import store from '@/store'
import { ThingsHelpers } from '@/helpers/mainExports.js'
export default {
  PROMISE_STATUS: Object.freeze({
    rejected: 'rejected',
    fulfilled: 'fulfilled'
  }),
  chunkArray(arr, size) {
    return Array.from({ length: Math.ceil(arr.length / size) }, (v, i) =>
      arr.slice(i * size, i * size + size)
    )
  },
  haveSameContents(a, b) {
    for (const v of new Set([...a, ...b]))
      if (a.filter(e => e === v).length !== b.filter(e => e === v).length)
        return false
    return true
  },
  getWindowsLabel(key) {
    const detention_tolerated = key.some(
      e => e == 'mrn:agent_condition:detention'
    )
    const no_report = key.some(e => e == 'mrn:agent_condition:no_report')
    if (detention_tolerated) {
      return 'detention_tolerated'
    } else if (no_report) {
      return 'no_report'
    } else {
      return 'title'
    }
  },
  isTimeLimit(condition) {
    return (
      condition === 'speed_limit' ||
      condition === 'fuel_consumption_deviation' ||
      condition === 'temperature' ||
      condition === 'fuel_charge'
    )
  },
  isGeofence(condition) {
    return condition === 'geofence'
  },
  isIgnition(condition) {
    return condition === 'ignition'
  },
  isDetention(condition) {
    return condition === 'detention'
  },
  getTimeZoneName(countryId) {
    switch (countryId) {
      case 'ar':
        return 'America/Argentina/Buenos_Aires'
      case 'cl':
        return 'America/Santiago'
      case 'uy':
        return 'America/Montevideo'
      default:
        return 'America/Argentina/Buenos_Aires'
    }
  },
  getEntities({ projection = null, page = 1, things = [], total = 0, retries = 0 } = {}) {
    return new Promise((resolve, reject) => {
      ThingsHelpers.getThingsList({ projection, page })
        .then(response => {
          things = things?.concat(response.args[0])

          if (total === 0) {
            total = response.kwargs.total || 0
          }

          if (things.length >= total || response.args[0].length === 0) {
            things = things.sort((a, b) =>
              a.info.label.toLowerCase() > b.info.label.toLowerCase() ? 1 : -1
            )
            resolve(things)
          } else {
            page++
            this.getEntities({ page, things, total })
              .then(response => {
                resolve(response)
              })
              .catch(error => {
                const errorText = ThingsHelpers.getErrorMessageByCode(
                  error.error
                )
                const snackbar = {
                  color: 'error',
                  text: errorText
                }
                store.dispatch('ui/setSnackbar', snackbar)
                reject(error)
              })
          }
        })
        .catch(error => {
          const errorText = ThingsHelpers.getErrorMessageByCode(error.error)
          const snackbar = {
            color: 'error',
            text: errorText
          }
          store.dispatch('ui/setSnackbar', snackbar)
          reject(error)
        })
    })
  }
}
